import { FC } from "react";
import UserPopupWrapper from "../../UserPopup/UserPopupWrapper";
import { fullNameFormat } from "../../../../helpers/Inicials";
import { dateToNiceString } from "../../../../helpers/dateToNiceString";
import Button from "../../../UiLib/Button/Button";

import Copy from "../../../../assets/document-copy.svg";
import { IMessage } from "../../../../common/api_interfaces/chat/IMessage";

const MessageHeader: FC<{ message: IMessage; onCopyUrl: (id: number) => void }> = ({
    message,
    onCopyUrl
}) => (
    <div className="input--chat__block--messages__message--all">
        <UserPopupWrapper userId={message.createdBy.id}>
            <div style={{ cursor: "pointer" }}>
                <div className="input--chat__block--messages__message--author">
                    {fullNameFormat(message.createdBy, "s n")}
                </div>
            </div>
        </UserPopupWrapper>
        
        <div className="input--chat__block--messages__message--role">
            {message.role}
        </div>
        
        <div className="input--chat__block--messages__message--date">
            <a href={`#message-${message.id}`}>
                {dateToNiceString(new Date(message.createdAt), "month dd, yyyy hh:mm")}
            </a>
        </div>
        
        <div className="input--chat__block--messages__message--all__copy">
            <Button
                title="Скопировать ссылку на сообщение"
                titlePosition="right"
                style={{ marginRight: "10px" }}
                callBack={() => onCopyUrl(message.id)}
                image={Copy}
            />
        </div>
        
        {message.updatedAt !== message.createdAt && (
            <a className="input--chat__block--messages__message--update">
                Изменено
            </a>
        )}
    </div>
);

export default MessageHeader;